<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(255, 255, 255, .85)"
  size="medium"
  [type]="spinner"
  [color]="color">
  <p [ngStyle]="{'color': color}">
    Please wait!!, while we are building your store...
  </p>
</ngx-spinner>
